module.exports = __webpack_public_path__ + "cdc3e7e5d4999ba9c360d77f4dfc99b8.svg";